import { render } from "./header-toolbar.vue?vue&type=template&id=634a93ad"
import script from "./header-toolbar.vue?vue&type=script&lang=js"
export * from "./header-toolbar.vue?vue&type=script&lang=js"

import "./header-toolbar.vue?vue&type=style&index=0&id=634a93ad&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__